import React, { PureComponent } from 'react';
import { range } from 'd3-array';

import Icon from '~/core/scripts/components/icon';
import './IconViz.styl';


class IconViz extends PureComponent {
  renderSection(d) {
    return (
      <div className="iconviz__section viz__section" key={`iconviz__section-${d.title}`}>
        <div className="iconviz__section-title viz__subheadline">
          {d.title}
        </div>
        <div className="iconviz__section-subtitle">
          <div className="iconviz__section-subtitle-text">
            {d.subtitle}
          </div>
          <div className="iconviz__section-subtitle-count">
            <strong>{d.count} Kekse</strong> ({d.kcal} kcal)
          </div>
        </div>
        <div className="iconviz__section-icons">
          {range(0, d.count).map((d, i) => <Icon key={`icon_${i}`} type={this.props.icon} />)}
        </div>
      </div>
    );
  }

  render() {
    const { title, legendText, icon, sections, sourceText } = this.props;
    return (
      <div className="iconviz">
        <div className="iconviz__headline viz__headline">{title}</div>
        <div className="iconviz__legend">
          <Icon type={icon} />
          <div className="iconviz__legend-text">
            {legendText}
          </div>
        </div>
        <div className="iconviz__sections">
          {sections.map(d => this.renderSection(d))}
        </div>
        <div className="iconviz__source">{sourceText}</div>
      </div>
    );
  }
}

export default IconViz;
